/**
 * Generates a unique ID using timestamp and random string
 * @param prefix Optional prefix for the ID
 * @returns A unique ID string
 */
export function generateUniqueId(prefix?: string): string {
  const id = `${Date.now()}-${Math.random().toString(36).substring(7)}`;
  return prefix ? `${prefix}_${id}` : id;
}
